import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "modal-dialog",
  role: "document"
}
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { class: "modal-header d-flex justify-content-end" }
const _hoisted_4 = { class: "modal-body" }
const _hoisted_5 = { class: "modal-footer" }

import { ref } from 'vue'

  // UI components
  import CloseButton from '@/components/UI/Button.vue'

  
export default /*@__PURE__*/_defineComponent({
  __name: 'ModalBase',
  emits: ["close"],
  setup(__props, { expose: __expose, emit: __emit }) {

  const emit = __emit

  const isOpen = ref(false)

  function close(): void {
    isOpen.value = false
    emit('close')
  }

  function open(): void {
    isOpen.value = true
  }

  __expose({ open, close })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "#modal-container" }, [
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (isOpen.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "modal show d-flex justify-content-center align-items-center",
              tabindex: "-1",
              role: "dialog",
              onClick: _withModifiers(close, ["self"])
            }, [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(CloseButton, {
                      classes: ['ts-x-black', 'bg-grey-200'],
                      onClick: close
                    })
                  ]),
                  _createElementVNode("div", _hoisted_4, [
                    _renderSlot(_ctx.$slots, "default")
                  ]),
                  _createElementVNode("div", _hoisted_5, [
                    _renderSlot(_ctx.$slots, "footer", {}, () => [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-secondary",
                        onClick: close
                      }, " Close ")
                    ])
                  ])
                ])
              ]),
              _cache[0] || (_cache[0] = _createElementVNode("div", { class: "modal-backdrop fade show" }, null, -1))
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 3
    })
  ]))
}
}

})